import { Box, Modal, Typography } from '@mui/material';
import { useContext, FC } from 'react';
import CartContext from '../contexts/CartContext';
import CartItem from './CartItem';
import { convertToPriceFormat, useScreenResolution } from '../utils/utils';

interface ICartModal {
  open: boolean;
  handleClose: () => void;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: '4px',
  boxShadow: 24,
  p: 4,
  overflow: 'hidden',
  outline: 'none'
};

const CartModal: FC<ICartModal> = ({ open, handleClose }) => {
  const {
    cartItems,
    cartTotalItems,
    cartTotalPrice,
    addToCart,
    removeFromCart,
  } = useContext(CartContext);
  const isDesktop = useScreenResolution();
  const modalContent = (
    <>
      <Typography
        id="modal-modal-title"
        variant="h6"
        component="h2"
      >
        Shopping Cart ({cartTotalItems})
      </Typography>
      <Box
        sx={{
          overflowY: 'scroll',
          '::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        maxHeight="550px"
      >
        {cartItems?.map((item) => (
          <CartItem
            item={item}
            key={`${item.id}${item.title}`}
            onAddClick={addToCart}
            onRemoveClick={removeFromCart}
          />
        ))}
      </Box>
      {cartTotalItems === 0 ? (
        <Typography variant="body1">No items in cart.</Typography>
      ) : (
        <>
          <hr style={{ margin: '15px 0' }} />
          <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>
            Total: {convertToPriceFormat(cartTotalPrice)}
          </Typography>
        </>
      )}
    </>
  );

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} width={isDesktop ? '500px' : '300px'}>
          {modalContent}
        </Box>
      </Modal>
    </>
  );
};

export default CartModal;
